import React, { useState, useContext } from 'react';
import proyectoContext from '../../context/proyectos/proyectoContext';

const NuevoProyecto = () => {

    // obtener el state del formulario
    const proyectosContext = useContext(proyectoContext);
    const { formulario, errorformulario, mostrarFormulario, agregarProyecto, mostrarError } = proyectosContext;

    // state para el proyecto
    const [proyecto, setProyecto] = useState({
        nombre: ''
    });

    // extraer nombre proyecto
    const { nombre } = proyecto;

    // lee los contenidos del input
    const onChangeProyecto = e => {
        setProyecto({
            ...proyecto,
            [e.target.name] : e.target.value
        })
    }

    // cuando el usuario envia (submit) el proyecto 
    const onSubmitProyecto = e => {
        e.preventDefault();

        // validar el proyecto
        if (nombre === '') {
            mostrarError();
            return;
        }

        // agregar el proy al state
        agregarProyecto(proyecto);

        // reiniciar el form
        setProyecto({
            nombre: ''
        })
    }

    // mostrar formulario
    const onClickFormulario = () => {
        mostrarFormulario();
    }

    return ( 
        <> 
        <button
            type="button"
            className="btn btn-block btn-primary"
            onClick= {onClickFormulario}
        >Nuevo Proyecto</button>
        {formulario 
            ? (
                <form
            className="formulario-nuevo-proyecto"
            onSubmit={onSubmitProyecto}
        >
            <input 
                type="text"
                className="input-text"
                placeholder="Nombre del Proyecto"
                name="nombre"
                value={ nombre }
                onChange={onChangeProyecto}
            />
            <input 
                type="submit"
                className="btn btn-primary btn-block"
                value="Agregar Proyecto"
            />
        </form>
            ) : null
        }
        { errorformulario ? <p className="mensaje error">El nombre del proyecto es obligatorio</p> : null}
        </>
    );
}
 
export default NuevoProyecto;